module.exports = __webpack_public_path__ + "static/img/image026.86ad3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image026.png
// module id = oBnJ
// module chunks = 1